import { css } from '@emotion/css';

const wrapper = css`
  text-align: center;
  margin-top: var(--spacings-6);
`;

const image = css`
  max-width: 142px;
  height: auto;
  margin: 0 auto;
`;

const header = css`
  &.MuiTypography-h4 {
    margin: var(--spacings-4) 0;
  }
`;

const actionButton = css`
  &.MuiButton-root {
    margin-top: var(--spacings-4);
    border-radius: var(--radius-1);
    background-color: var(--colors-primary-900);

    &:hover {
      background-color: var(--colors-primary-600);
    }
  }
`;

const LoadErrorStyles = {
  wrapper,
  image,
  header,
  actionButton,
};

export default LoadErrorStyles;
